import * as React from 'react';
import { Field } from 'formik';
import { withTranslation } from 'react-i18next';
import { Select } from '../base-atoms/Select';
import { min, max, setMonth } from 'date-fns';
import { getDaysInMonth } from 'date-fns';
import { FieldError } from '../FieldError';

const MINIMAL_YEAR = 1900;

function makeYearOptions(start, end, currentDate) {
  const options = [];
  for (let i = min([start, currentDate]).getFullYear(); i <= max([end, currentDate]).getFullYear(); i += 1) {
    options.push(<option key={i} value={i} children={i} />);
  }
  return options;
}

export class Renderer extends React.Component {
  makeMonthOptions() {
    const options = [];
    const date = new Date();

    for (let i = 0; i < 12; i += 1) {
      const then = setMonth(date, i);
      options.push(
        <option key={i} value={i}>
          {this.props.t('dateFormatMonth', { date: new Date(then) })}
        </option>,
      );
    }
    return options;
  }

  render() {
    return (
      <div className="birthdate-select">
        <div className="birthdate-select__month">
          <Field name="birth_month">
            {({ field }) => (
              <>
                <Select {...field} name="birth_month">
                  <option value="" disabled>
                    {this.props.t('Month')}
                  </option>
                  {this.makeMonthOptions()}
                </Select>
                <FieldError name="birth_month" />
              </>
            )}
          </Field>
        </div>
        <div className="birthdate-select__day">
          <Field name="birth_day">
            {({ field, form }) => {
              const month = form.values.birth_month ?? 0;
              const year = form.values.birth_year ?? MINIMAL_YEAR;
              const numberOfDaysInMonth = getDaysInMonth(new Date(year, month));
              const days = Array.from({ length: numberOfDaysInMonth }, (_, i) => i + 1);

              return (
                <>
                  <Select {...field} name="birth_day">
                    <option value="" disabled>
                      {this.props.t('Day')}
                    </option>
                    {days.map((day) => (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    ))}
                  </Select>
                  <FieldError name="birth_day" />
                </>
              );
            }}
          </Field>
        </div>
        <div className="birthdate-select__year">
          <Field name="birth_year">
            {({ field }) => (
              <>
                <Select {...field} name="birth_year">
                  <option value="" disabled>
                    {this.props.t('Year')}
                  </option>
                  {makeYearOptions(new Date(MINIMAL_YEAR, 0), new Date(), new Date())}
                </Select>
                <FieldError name="birth_year" />
              </>
            )}
          </Field>
        </div>
      </div>
    );
  }
}

export const BirthDateSelect = withTranslation()(Renderer);
